React = require 'react'
t = require('views/internal/recup-with-helpers')('home')

module.exports = class HomeFeedbackLink extends React.Component
  displayName: 'HomeFeedbackLink'

  render: t.renderable ->
    { memberId } = @props
    t.a '.home-feedback-link.quiet', { target: "_blank", href: "https://trello.typeform.com/to/mpWwl5?memberid=#{memberId}" }, ->
      t.span '.home-feedback-icon .icon-sm .icon-information'
      t.span '.home-feedback-text', ->
        t.format 'feedback'


// WEBPACK FOOTER //
// ./app/scripts/views/home/home-feedback-link.coffee